<script>
/**
 * 基础选择器，提供基本样式和功能
 */
import PopWindow from '@/components/PopWindow';

export default {
  name: 'base_selector',
  components: {
    PopWindow,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 800,
    },
    position: {
      type: String,
      default: 'right',
      validator(val) {
        return ['left', 'right', 'bottom', 'top'].includes(val);
      },
    },
    zIndex: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    document.addEventListener('keyup', this.onKeyUp);
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.onKeyUp);
  },
  computed: {
    windowStyle() {
      return {
        height: ['left', 'right'].includes(this.position) ? '100%' : `${this.width}px`,
        width: ['top', 'bottom'].includes(this.position) ? '100%' : `${this.width}px`,
      };
    },
  },
  methods: {
    onClose() {
      this.$emit('input', false);
      this.$emit('close', false);
    },
    onKeyUp(e) {
      if (e.keyCode === 27) {
        this.onClose();
      }
    },
  },
};
</script>

<template lang="pug">
pop-window(
  :visible="value"
  :position="position"
  :zIndex="zIndex"
  @onBackgroundClick="onClose")
  .resourcs-window(:style="windowStyle")
    .header
      .title-box
        strong.title(v-if="title")
          | {{ title }}
        slot(name="header")
      el-button.btn.close-btn(@click="onClose")
        i.el-icon-close
    .content(v-loading="$store.state.loading")
      slot
</template>

<style lang="stylus" scoped>
.resourcs-window
  height 100%
  background #fff
  position relative
  display flex
  flex-direction column
  .header
    border-bottom 1px solid #ddd
    padding-left 12px
    display flex
    justify-content space-between
    align-items center
    width 100%
    height 60px
    flex-shrink 0
    .title-box
      width 100%
      .title
        font-size 16px
        vertical-align middle
    .close-btn
      flex-shrink 0
      width 48px
      height 48px
      border-radius 0
      border none
      font-size 18px
      margin 0 10px
      &:hover
        background #ffffff
  .content
    height 100%
    overflow auto
    -webkit-overflow-scrolling touch
    padding 14px
    background-color #f8f8f8
</style>



// WEBPACK FOOTER //
// Window.vue?63ad6d9a